import {
  SET_TRENDING_PRODUCTS_LOADING,
  GET_TRENDING_PRODUCTS_SUCCESS,
  GET_TRENDING_PRODUCTS_ERROR,
} from '../actions/types';

const initialState = {
  isLoading: false,
  trendingProducts: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false,
    nextPage: null,
    prevPage: null,
  },
  error: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_TRENDING_PRODUCTS_LOADING:
      return {
        ...state,
        isLoading: payload,
      };

    case GET_TRENDING_PRODUCTS_SUCCESS:
      return {
        ...state,
        trendingProducts: payload.data,
        pagination: payload.pagination,
        isLoading: false,
        error: null,
      };

    case GET_TRENDING_PRODUCTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    default:
      return state;
  }
}
